export default {
  FETCH_SEGMENTS_REQUEST: 'FETCH_SEGMENTS_REQUEST',
  FETCH_SEGMENTS_ERROR: 'FETCH_SEGMENTS_ERROR',
  FETCH_SEGMENTS_SUCCESS: 'FETCH_SEGMENTS_SUCCESS',

  CREATE_SEGMENT_REQUEST: 'CREATE_SEGMENT_REQUEST',
  CREATE_SEGMENT_ERROR: 'CREATE_SEGMENT_ERROR',
  CREATE_SEGMENT_SUCCESS: 'CREATE_SEGMENT_SUCCESS',

  UPDATE_SEGMENT_REQUEST: 'UPDATE_SEGMENT_REQUEST',
  UPDATE_SEGMENT_ERROR: 'UPDATE_SEGMENT_ERROR',
  UPDATE_SEGMENT_SUCCESS: 'UPDATE_SEGMENT_SUCCESS',

  DELETE_SEGMENT_REQUEST: 'DELETE_SEGMENT_REQUEST',
  DELETE_SEGMENT_ERROR: 'DELETE_SEGMENT_ERROR',
  DELETE_SEGMENT_SUCCESS: 'DELETE_SEGMENT_SUCCESS',

  SET_SELECTED_SEGMENT: 'SET_SELECTED_SEGMENT',
  SET_SEGMENT_OPEN: 'SET_SEGMENT_OPEN',
  CONFIRM_SEGMENT_DELETE: 'CONFIRM_SEGMENT_DELETE',
}
